import { StyleSheet } from 'react-native';

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  itemContainer: theme => ({
    marginTop: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    paddingHorizontal: 16,
    shadowColor: Colors.linegrey,
    elevation: 2,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 4,
    shadowOpacity: 1,
  }),
  title: theme => ({
    fontSize: 16,
    letterSpacing: 0,
    marginBottom: 3,
    color: theme.colors.text.primaryGrey,
    fontFamily: Fonts.VodafoneRg,
  }),
  container: { marginBottom: 33 },
  titleCardStyle: { fontSize: 18, lineHeight: 24, paddingLeft: 3 },
  permissionsItem: (theme, hasIcon, isLast) => ({
    borderBottomColor: theme.colors.borderColorThree,
    paddingBottom: 16,
    paddingTop: 16,
    ...(!hasIcon && { marginStart: 32 }),
    ...((!hasIcon || isLast) && { borderBottomWidth: 0 }),
    marginEnd: 3,
  }),
});
